<template>
    <div class="user_list_page">
        <div class="filter_box">
            <div class="flex">
                <a-input v-model="filterData.operation" style="width: 200px" class="mr12" placeholder="操作内容" allow-clear @pressEnter="getData(1)" />
                <a-input v-model="filterData.operator" style="width: 200px" class="mr12" placeholder="操作人" allow-clear @pressEnter="getData(1)" />
                <a-button class="mr12" type="primary" @click="getData(1)">搜索</a-button>
                <a-button class="mr12" @click="resetSearch">重置</a-button>
            </div>
        </div>
        <a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
                 :loading="loading" :scroll="{ x: 'max-content' }">
            <template slot="operationTime" slot-scope="text">
                <span>{{ text }}</span>
            </template>
        </a-table>
    </div>
</template>

<script>
    import { operationLogApi } from "../../api/index";

    export default {
        name: "operationLog",
        data() {
            return {
                filterData: {
                    operation: "",
                    operator: "",
                },
                columns: [
                    {
                        title: "操作人",
                        dataIndex: "operator",
                        key: "operator",
                        width: 150,
                    },
                    {
                        title: "操作内容",
                        dataIndex: "operation",
                        key: "operation",
                        ellipsis: true,
                    },
                    {
                        title: "操作时间",
                        dataIndex: "operationTime",
                        key: "operationTime",
                        width: 180,
                        scopedSlots: { customRender: "operationTime" },
                    },
                ],
                tableData: [],
                pageInfo: {
                    pageSize: 20,
                    current: 1,
                    total: 0,
                    showTotal: (total) => `合计 ${total} 条记录`,
                    // showSizeChanger: true,
                    // pageSizeOptions: ["10", "20", "50", "100"],
                },
                loading: false,
            };
        },
        mounted() {
            const storedQuery = localStorage.getItem('operationLog_searchQuery');
            if (storedQuery) {
                try {
                    this.filterData = JSON.parse(storedQuery);
                } catch (e) {}
            }
            const storedPage = localStorage.getItem('operationLog_pageNo');
            this.getData(storedPage ? parseInt(storedPage) : 1);
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('operationLog_searchQuery', JSON.stringify(this.filterData));
            localStorage.setItem('operationLog_pageNo', this.pageInfo.current);
            next();
        },
        methods: {
            resetSearch() {
                this.filterData = { operation: "", operator: "" };
                this.getData(1);
            },
            changePage(page) {
                this.pageInfo.current = page.current;
                this.pageInfo.pageSize = page.pageSize;
                this.getData(this.pageInfo.current);
            },
            getData(page = 1) {
                this.pageInfo.current = page;
                if (this.loading) return;
                this.loading = true;
                operationLogApi({
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,
                    operation: this.filterData.operation || undefined,
                    operator: this.filterData.operator || undefined,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = res.resultData.dataList || [];
                            this.pageInfo.total = res.resultData.totalNum || 0;
                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="less" scoped>
    .user_list_page {
        width: 100%;
        height: 100%;
        padding: 20px;
        background: #ffffff;

        .filter_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
        }

        .mr12 {
            margin-right: 12px;
        }
    }
</style>
